import { computed } from '@preact/signals-react'
import type { GameCatalogDep, GameCatalogGame } from './gameCatalog.types'
import type { GameRegistry } from '../gameRegistry/gameRegistry.types'
import type { DynamicGameCatalogEntry } from '../dynamicGameLoader/dynamicGameLoader.types'

function toCatalogGame(entry: DynamicGameCatalogEntry): GameCatalogGame {
  return {
    gameId: entry.gameId,
    publisherSlug: entry.gameId.split('/')[0],
    displayName: entry.displayName || entry.gameId,
    description: entry.description,
    minPlayers: entry.minPlayers ?? 2,
    maxPlayers: entry.maxPlayers ?? entry.minPlayers ?? 2,
    thumbnailUrl: entry.thumbnailUrl,
    launchChannel: entry.launchChannel,
    availableChannels: entry.availableChannels,
    owned: entry.owned === true,
    developmentProgress: entry.developmentProgress,
  }
}

export function makeGameCatalogDep(gameRegistry: GameRegistry): GameCatalogDep {
  const games = computed<GameCatalogGame[]>(() => (gameRegistry.gamesSignal?.value || []).map(toCatalogGame))

  const lookupGames = async (gameIds: string[]): Promise<GameCatalogGame[]> => {
    const entries = (await gameRegistry.lookupCatalogEntries?.(gameIds)) ?? []
    return entries.map(toCatalogGame)
  }

  return {
    games,
    getGame: (gameId) => games.value.find((g) => g.gameId === gameId),
    lookupGames,
  }
}
